<template>
  <div class="dashboard-container">
    <el-row justify="end" style="margin-bottom:20px;">
      <el-col :span="isMB?24:(showMoney?8:6)" :style="showMoney?'margin-bottom:20px;':''" :class="isMB?'':'pcBlock'">
        <div class="el-col-box statistics">
          <div class="title">本月累计通话时长</div>
          <div class="value">{{blockData.Minutes}}</div>
          <div class="minute">分钟</div>
        </div>
      </el-col>
      <el-col :span="isMB?24:8" style="margin-bottom:20px;" v-if="showMoney" :class="isMB?'':'pcBlock'">
        <div class="el-col-box statistics">
          <div class="title">本月累计消费金额</div>
          <div class="value">{{blockData.ConsumptionAmount}}</div>
          <div class="minute">元</div>
        </div>
      </el-col>
      <el-col :span="isMB?24:8" style="margin-bottom:20px;" v-if="showMoney" :class="isMB?'':'pcBlock'">
        <div class="el-col-box statistics">
          <div class="title">本月累计充值金额</div>
          <div class="value">{{blockData.RechargeAmount}}</div>
          <div class="minute">元</div>
        </div>
      </el-col>
      <el-col :span="isMB?24:(showMoney?8:6)" :style="isMB&&showMoney?'margin-bottom:20px;':''" :class="isMB?'':'pcBlock'">
        <div class="el-col-box statistics">
          <div class="title">话机连接正常数量</div>
          <div class="value">{{blockData.NormalCount}}</div>
          <div class="minute">部</div>
        </div>
      </el-col>
      <el-col :span="isMB?24:(showMoney?8:6)" :style="isMB&&showMoney?'margin-bottom:20px;':''" :class="isMB?'':'pcBlock'">
        <div class="el-col-box statistics">
          <div class="title">话机连接异常数量</div>
          <div class="value">{{blockData.UnNormalCount}}</div>
          <div class="minute">部</div>
        </div>
      </el-col>
      <el-col :span="isMB?24:(showMoney?8:6)" :class="isMB?'':'pcBlock'">
        <div class="el-col-box statistics">
          <div class="title">当天累计通话时长</div>
          <div class="value">{{blockData.DayMinutes}}</div>
          <div class="minute">分钟</div>
        </div>
      </el-col>
    </el-row>
    <el-row justify="end">
      <el-col :span="isMB?24:12" v-if="showMoney">
        <div class="el-col-box" style="margin-bottom:20px;">
          <span style="color:#ff9900;margin-right:20px;font-size:18px;font-weight:bold;">扣费金额走势图</span>
          <line-chart ref="lineChart" :height="isMB?'370px':'320px'"></line-chart>
        </div>
      </el-col>
      <el-col :span="isMB?24:12" v-if="showMoney">
        <div class="el-col-box" style="margin-bottom:20px;">
          <span style="color:#ff9900;margin-right:20px;font-size:18px;font-weight:bold;">充值金额走势图</span>
          <line-chart2 ref="lineChart2" :height="isMB?'370px':'320px'"></line-chart2>
        </div>
      </el-col>
      <el-col :span="isMB?24:12">
        <div class="el-col-box">
          <span style="color:#ff9900;margin-right:20px;font-size:18px;font-weight:bold;">七天通话时长走势图</span>
          <line-chart3 ref="lineChart3" :height="isMB?'370px':'320px'"></line-chart3>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import date from "@/components/dashboard/date/date";
import lineChart from "@/components/dashboard/charts/lineChart";
import lineChart2 from "@/components/dashboard/charts/lineChart2";
import lineChart3 from "@/components/dashboard/charts/lineChart3";

export default {
  name: "home",
  components: {
    date,
    lineChart,
    lineChart2,
    lineChart3,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
      api: require("@/api/consume/account").default,
      blockData: {
        ConsumptionAmount: 0,
        Minutes: 0,
        RechargeAmount: 0,
        NormalCount: 0,
        UnNormalCount: 0,
        DayMinutes: 0,
      },
    };
  },
  computed: {
    showMoney() {
      return this.$permission.can("显示金额","/m_index");
    }
  },
  mounted() {
    this.getData();
    let self = this;
    setInterval(function () {
      self.getData();
    }, 300000)
  },
  methods: {
    getData() {
      this.api.getWorkbenchStat().then(res => {
        // this.ConsumptionAmount = res.Data.ConsumptionAmount;
        // this.Minutes = res.Data.Minutes;
        // this.RechargeAmount = res.Data.RechargeAmount;
        this.blockData = res.Data;
        if(this.showMoney) {
          this.$refs.lineChart.initChart(res.Data.ConsumptionStat);
          this.$refs.lineChart2.initChart(res.Data.RechargeStat);
        }
        this.$refs.lineChart3.initChart(res.Data.MinuteStat);
      })
    },
  },
};
</script>
<style  lang="scss" scoped>
.dashboard-container {
  padding: 32px 35px 15px;
  background-color: rgb(240, 242, 245);
  position: relative;
  height: calc(100vh - 84px);
  overflow: auto;
  // background: url("../assets/bg.png") center bottom no-repeat;
  @media (max-width: 1000px) {
    height: 100%;
    margin-top: -10px;
  }
  background-size: 100% 100%;
}

.test_box {
  position: absolute;
  z-index: 999;
  padding: 5px;
  top: 0;
}

.test_box1 {
  width: 339px;
  background-color: #ffffff;
  border: 1px solid #959595;
}

.el-col-box {
  padding: 15px;
  position: relative;
  width: 100%;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  height: 330px;
  overflow: hidden;
  .el-row {
    margin: 0px;
  }

  .box-left {
    width: 120px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .box-right {
    width: calc(100% - 120px);
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    .count-title {
      font-size: 28px;
      font-weight: bold;
      color: #808080;
      text-align: right;
    }
    .count {
      font-size: 48px;
      text-align: right;
    }
  }

  .footer {
    font-size: 30px;
    position: absolute;
    width: calc(100% - 30px);
    bottom: 18px;
    text-align: right;
    border-top: 1px solid #dcdfe6;
    span {
      cursor: pointer;
    }
  }
}
.statistics {
  display:flex;
  flex-direction:column;
  justify-content:space-between;
  font-size: 18px;
  font-weight: bold;
  height: 150px;
  .title{
    color: #ff9900;
  }
  .value {
    text-align: center;
    color: #009966;
    font-size: 52px;
    margin-bottom: -15px;
    @media screen and(max-width:767px) {
      margin-bottom: -20px;
    }
  }
  .minute{
    text-align: right;
    color: #bbb;
  }
}
.el-col {
  padding: 0 8px !important;
}
.pcBlock{
  // width: 33.3%;
}
</style>